import { MEMBERSHIP_PAGE_PATH } from '~/common/url.constants';

export const AppStatesToParams = {
    root_core_resetPassword: {
        title: 'Notifications',
        backToUrl: 'root_core_navigation_pipeline'
    },
    root_core_setPassword: {
        title: 'Notifications',
        backToUrl: 'root_core_navigation_pipeline'
    },
    root_core_resetPasswordForFile: {
        title: 'Notifications',
        backToUrl: 'root_core_navigation_pipeline'
    },
    root_core_resetPasswordForWorkspace: {
        title: 'Notifications',
        backToUrl: 'root_core_navigation_pipeline'
    },
    root_core_resetPasswordForEvent: {
        title: 'Notifications',
        backToUrl: 'root_core_navigation_pipeline'
    },
    root_core_resetPasswordForExternalSite: {
        title: 'Notifications',
        backToUrl: 'root_core_navigation_pipeline'
    },
    root_core_admin: {
        title: 'Notifications',
        backToUrl: 'root_core_navigation_pipeline'
    },
    root_core_navigation_activity_notifications: {
        title: 'Notifications',
        backToUrl: 'root_core_navigation_pipeline'
    },
    root_core_navigation_files: {
        title: 'Files'
    },
    root_core_navigation_tools_mobile: {
        title: 'Tools',
        mobileNavPrimary: true
    },
    root_core_navigation_contacts: {
        title: 'Contacts',
        backToUrl: 'root_core_navigation_home'
    },
    root_core_navigation_contact_view: {
        hideMobileNav: true
    },
    root_core_navigation_contact_view_tab: {
        hideMobileNav: true
    },
    root_core_navigation_organizations: {
        hideMobileNav: true
    },
    root_core_navigation_organization_view: {
        hideMobileNav: true
    },
    root_core_navigation_pipeline: {
        title: 'Projects',
        mobileNavPrimary: true
    },
    root_core_navigation_home: {
        title: 'Home',
        mobileNavPrimary: true,
        showPlusButton: true
    },
    root_core_navigation_automations: {
        title: 'Automations'
    },
    root_core_navigation_newautomations: {
        title: 'New Automations'
    },
    root_core_navigation_invite: {
        title: 'Referral dashboard'
    },
    root_core_navigation_invite_referrals: {
        title: 'Referral dashboard'
    },
    root_core_navigation_invite_track: {
        title: 'Referral dashboard'
    },
    root_core_navigation_invite_resources: {
        title: 'Referral dashboard'
    },
    root_core_navigation_invite_perks: {
        title: 'Referral dashboard'
    },
    root_core_navigation_calendarAbstract: {
        title: 'Calendar',
        backToUrl: 'root_core_navigation_tools_mobile'
    },
    root_core_navigation_calendar: {
        title: 'Calendar',
        backToUrl: 'root_core_navigation_tools_mobile'
    },
    root_core_navigation_scheduling: {
        title: 'Scheduling',
        showCreateSchedule: true
    },
    root_core_navigation_calendarNewAbstract: {
        title: 'Calendar',
        backToUrl: 'root_core_navigation_tools_mobile'
    },
    root_core_navigation_calendar_new: {
        title: 'Calendar',
        backToUrl: 'root_core_navigation_tools_mobile'
    },
    root_core_navigation_scheduling_new: {
        title: 'Scheduling',
        showCreateSchedule: true
    },
    root_core_navigation_batch_email: {
        title: 'Batch Emails'
    },
    root_core_navigation_yearInReview: {
        title: 'HoneyBook Highlights'
    },
    root_core_accountSetup: {
        hideMobileNav: true
    },
    root_core_navigation_emptyEvent: {
        hideMobileNav: true
    },
    root_core_navigation_event_wrapper: {
        hideMobileNav: true
    },
    root_core_navigation_event: {
        title: 'Time Tracker',
        backToUrl: 'root_core_navigation_tools_mobile'
    },
    root_core_navigation_event_overview: {
        title: 'Time Tracker',
        backToUrl: 'root_core_navigation_tools_mobile'
    },
    root_core_navigation_event_workspace: {
        title: 'Time Tracker',
        backToUrl: 'root_core_navigation_tools_mobile'
    },
    root_core_navigation_event_workspace_feed: {
        hideMobileNav: true
    },
    root_core_navigation_event_workspace_overview: {
        hideMobileNav: true
    },
    root_core_navigation_event_workspace_settings: {
        hideMobileNav: true
    },
    root_core_navigation_event_workspace_files: {
        hideMobileNav: true
    },
    root_core_navigation_event_workspace_tasks: {
        hideMobileNav: true
    },
    root_core_navigation_event_workspace_payments: {
        hideMobileNav: true
    },
    root_core_navigation_event_workspace_notes: {
        hideMobileNav: true
    },
    root_core_navigation_event_workspace_details: {
        hideMobileNav: true
    },
    root_core_navigation_time_tracker: {
        title: 'Time Tracker',
        backToUrl: 'root_core_navigation_tools_mobile'
    },
    root_core_navigation_reports: {
        title: 'Reports',
        backToUrl: 'root_core_navigation_tools_mobile'
    },
    root_core_navigation_bookkeeping: {
        title: 'Reports',
        backToUrl: 'root_core_navigation_tools_mobile'
    },
    root_core_navigation_bookkeeping_reports: {
        title: 'Reports',
        backToUrl: 'root_core_navigation_tools_mobile'
    },
    root_core_navigation_reports_analytics: {
        title: 'Reports',
        backToUrl: 'root_core_navigation_tools_mobile'
    },
    root_core_navigation_bookkeeping_reports_analytics: {
        title: 'Reports',
        backToUrl: 'root_core_navigation_tools_mobile'
    },
    root_core_navigation_reports_payments: {
        title: 'Payments',
        backToUrl: 'root_core_navigation_tools_mobile'
    },
    root_core_navigation_bookkeeping_reports_payments: {
        title: 'Payments',
        backToUrl: 'root_core_navigation_tools_mobile'
    },
    root_core_navigation_expenses: {
        title: 'Bookkeeping'
    },
    root_core_navigation_bookkeeping_expenses: {
        title: 'Bookkeeping'
    },
    root_core_navigation_finance: {
        title: 'Balance',
        backToUrl: 'root_core_navigation_home'
    },
    root_core_navigation_finance_overview: {
        title: 'Overview',
        backToUrl: 'root_core_navigation_home'
    },
    root_core_navigation_finance_taxes: {
        title: 'Tax Hub',
        backToUrl: 'root_core_navigation_home'
    },
    root_core_navigation_finance_payroll: {
        title: 'Payroll'
    },
    root_core_navigation_finance_expenses: {
        title: 'Expenses'
    },
    root_core_navigation_invoices: {
        title: 'Invoices'
    },
    root_core_navigation_files_hub: {
        title: 'Bookkeeping'
    },
    root_core_navigation_profit_loss: {
        title: 'Bookkeeping'
    },
    root_core_navigation_bookkeeping_reports_profit_loss: {
        title: 'Bookkeeping'
    },
    root_core_navigation_capital: {
        title: 'Capital'
    },
    root_core_plaid_oauth: {
        title: 'Settings',
        backToUrl: 'root_core_navigation_pipeline'
    },
    root_core_navigation_settings: {
        title: 'Settings',
        backToUrl: 'root_core_navigation_pipeline'
    },
    root_core_navigation_bookkeeping_settings: {
        title: 'Settings',
        backToUrl: 'root_core_navigation_pipeline'
    },
    root_core_navigation_settings_mobile: {
        title: 'Settings',
        mobileNavPrimary: true,
        backToUrl: 'root_core_navigation_pipeline'
    },
    root_core_navigation_settings_account: {
        title: 'My Account'
    },
    root_core_navigation_settings_company: {
        title: 'Company Settings',
        backToUrl: 'root_core_navigation_pipeline'
    },
    root_core_navigation_bookkeeping_settings_company: {
        title: 'Company Settings',
        backToUrl: 'root_core_navigation_pipeline'
    },
    root_core_navigation_settings_company_mobile: {
        title: 'Company',
        backToUrl: 'root_core_navigation_pipeline'
    },
    root_core_navigation_settings_company_team: {
        title: 'Account Setup Status'
    },
    root_core_navigation_settings_company_account_access: {
        title: 'Account Setup Status'
    },
    root_core_navigation_settings_company_preferences: {
        title: 'Account Setup Status'
    },
    root_core_navigation_settings_company_ai_preferences: {
        title: 'Account Setup Status'
    },
    root_core_navigation_settings_company_account_setup: {
        title: 'Account Setup Status'
    },
    root_core_navigation_settings_companySettings: {
        title: 'Account'
    },
    root_core_navigation_settings_companySettings_library: {
        title: 'Library'
    },
    root_core_navigation_templates: {
        title: 'Templates',
        backToUrl: 'root_core_navigation_home'
    },
    root_core_navigation_my_templates: {
        title: 'Templates',
        backToUrl: 'root_core_navigation_home'
    },
    root_core_navigation_my_templates_preview: {
        title: 'My Templates'
    },
    root_core_navigation_flows_template_gallery: {
        title: 'Templates',
        backToUrl: 'root_core_navigation_home'
    },
    root_core_navigation_tasks: {
        title: 'Task Management',
        backToUrl: 'root_core_navigation_tools_mobile'
    },
    root_core_navigation_facebook_leads: {
        title: 'Facebook/Instagram Leads',
        backToUrl: 'root_core_navigation_tools_mobile'
    },
    root_core_navigation_settings_companySettings_automation: {
        title: 'Automation'
    },
    root_core_navigation_settings_company_quickbooks: {
        title: 'QuickBooks'
    },
    root_core_navigation_bookkeeping_settings_company_quickbooks: {
        title: 'QuickBooks'
    },
    root_core_workspaceFileRedirection: {
        title: 'Company brands',
        showPlusButton: true
    },
    root_core_workspaceFilePaymentRedirection: {
        title: 'Company brands',
        showPlusButton: true
    },
    root_core_workspaceFile: {
        title: 'Company brands',
        showPlusButton: true
    },
    root_core_workspaceFile_stepProposal: {
        title: 'Company brands',
        showPlusButton: true
    },
    root_core_workspaceFile_stepQuestionnaire: {
        title: 'Company brands',
        showPlusButton: true
    },
    root_core_workspaceFile_brochure: {
        title: 'Company brands',
        showPlusButton: true
    },
    root_core_workspaceFile_timeline: {
        title: 'Company brands',
        showPlusButton: true
    },
    root_core_workspaceFile_stepAgreement: {
        title: 'Company brands',
        showPlusButton: true
    },
    root_core_workspaceFile_stepPayment: {
        title: 'Company brands',
        showPlusButton: true
    },
    root_core_questionnaireSubmitted: {
        title: 'Company brands',
        showPlusButton: true
    },
    root_core_receipt: {
        title: 'Company brands',
        showPlusButton: true
    },
    root_core_navigation_brands: {
        title: 'Company brands',
        showPlusButton: true
    },
    root_core_navigation_setup: {
        title: 'Setup Guide'
    }
};

export const AppStatesToUrl = {
    root_core: '/',
    root_core_googleOAuth2Callback: '/googleOAuth2Callback',
    root_core_zoomOAuth2Callback: '/zoomOAuth2Callback',
    root_core_canvaOAuth2Callback: '/canvaOAuth2Callback',
    root_core_calendlyOAuth2Callback: '/calendlyOAuth2Callback',
    root_core_intellumSSORedirect: '/intellumOAuth',
    root_core_nylasOAuth2Callback: '/nylasOAuth2Callback',
    root_core_quickbooksOAuth2Callback: '/quickbooksOAuth2Callback',
    root_core_pictimeOAuth2Callback: '/pictimeOAuth2Callback',
    root_core_navigation_client: '/client_navigation',
    root_core_login: '/login',
    root_core_community_redirect: '/community_redirect',
    root_core_clientLogin: '/client_login',
    root_core_signup: '/signup',
    root_core_linkExpired: '/link/expired/:link_id/:link_token',
    root_core_resolveLink: '/link/resolve/:link_id/:link_token',
    root_core_resetPassword: '/app/reset',
    root_core_setPassword: '/set/:user_id/:guid',
    root_core_resetPasswordForFile: '/reset/:user_id/:guid/file/:file_id',
    root_core_resetPasswordForWorkspace:
        '/reset/:user_id/:guid/event/:event_id/workspace/:workspace_id',
    root_core_resetPasswordForEvent: '/reset/:user_id/:guid/event/:event_id',
    root_core_resetPasswordForExternalSite:
        '/reset/:user_id/:guid/external_site',
    root_core_admin: '/admin/',
    root_core_navigation_activity_notifications: '/activity_notifications',
    root_core_navigation_files: '/files',
    root_core_navigation_tools_mobile: '/tools',
    root_core_navigation_business_tools: '/business_tools',
    root_core_navigation_contacts: '/contacts',
    root_core_navigation_contact_view: '/contacts/:contact_id',
    root_core_navigation_contact_view_tab: '/contacts/:contact_id/:selectedTab',
    root_core_navigation_organizations: '/organizations',
    root_core_navigation_organization_view: '/organizations/:organization_id',
    root_core_navigation_pipeline: '/pipeline',
    root_core_navigation_home: '/home',
    root_core_navigation_automations: '/automations',
    root_core_navigation_newautomations: '/newautomations',
    root_core_navigation_newautomations_builder:
        '/newautomations/:automation_id',
    root_core_navigation_newautomations_execution_view:
        '/newautomations/runs/:execution_id',
    root_core_navigation_automation_setup: '/automations/:automation_id',
    root_core_navigation_newautomations_introduction:
        '/newautomations/introduction',
    root_core_automations_apply:
        '/workspace/:workspace_id/automations/:automation_id',
    root_core_oneFlow: '/flow/:flow_id',
    root_core_oneFlowWithAction: '/flow/:flow_id/:action',
    root_core_oneFlowPreview: '/flow/:flow_id/preview',
    root_core_oneFlowWizardPreview: '/flow/:flow_id/edit/preview',
    root_core_oneFlowPreviewWithPageName: '/flow/:flow_id/:pageName',
    root_core_oneFlowTemplateGalleryPreview:
        '/flow/:flow_id/template/:template_id/preview/:pageName',
    root_core_native: '/native',
    root_core_navigation_invite: '/invite',
    root_core_navigation_invite_referrals: '/invite/referrals',
    root_core_navigation_invite_track: '/invite/track',
    root_core_navigation_invite_resources: '/invite/resources',
    root_core_navigation_invite_perks: '/invite/perks',
    root_core_navigation_calendar: '/calendar',
    root_core_navigation_scheduling: '/scheduling',
    root_core_sessionConfig: '/session/:sessionId/user/:userId',
    root_core_navigation_calendar_new: '/calendarnew',
    root_core_navigation_scheduling_new: '/schedulingnew',
    root_core_navigation_batch_email: '/batch_emails',
    root_core_onboardingGuidance: '/onboading_guide',
    root_core_onboardingMobileQuiz: '/welcome/:step',
    root_core_onboardingQuiz: '/freetrial/:step',
    root_core_navigation_yearInReview: '/year_in_review',
    root_core_accountSetup: '/account_setup',
    root_core_navigation_emptyEvent: '/event/empty',
    root_core_navigation_event_wrapper: '/event',
    root_core_navigation_event: '/event/:event_id',
    root_core_navigation_event_overview: '/event/:event_id/overview',
    root_core_navigation_event_workspace:
        '/event/:event_id/workspace/:workspace_id',
    root_core_navigation_event_workspace_feed:
        '/event/:event_id/workspace/:workspace_id/activity',
    root_core_navigation_event_workspace_feed_item:
        '/event/:event_id/workspace/:workspace_id/activity/:feed_item_id',
    root_core_navigation_event_workspace_overview:
        '/event/:event_id/workspace/:workspace_id/overview',
    root_core_navigation_event_workspace_files:
        '/event/:event_id/workspace/:workspace_id/files',
    root_core_navigation_event_workspace_payments:
        '/event/:event_id/workspace/:workspace_id/payments',
    root_core_navigation_event_workspace_notes:
        '/event/:event_id/workspace/:workspace_id/notes',
    root_core_navigation_event_workspace_details:
        '/event/:event_id/workspace/:workspace_id/details',
    root_core_navigation_event_workspace_tasks:
        '/event/:event_id/workspace/:workspace_id/tasks',
    root_core_navigation_event_workspace_settings:
        '/event/:event_id/workspace/:workspace_id/settings',
    root_core_navigation_time_tracker: '/time_tracker',
    root_core_navigation_reports: '/reports',
    root_core_navigation_reports_analytics: '/reports/analytics',
    root_core_navigation_reports_payments: '/reports/payments',
    root_core_navigation_expenses: '/expenses',
    root_core_navigation_finance: '/finance',
    root_core_navigation_finance_overview: '/finance/overview',
    root_core_navigation_finance_expenses: '/finance/expenses',
    root_core_navigation_finance_payroll: '/payroll',
    root_core_navigation_invoices: '/invoices',
    root_core_navigation_files_hub: '/files_hub',
    root_core_navigation_profit_loss: '/profit-loss',
    root_core_navigation_capital: '/capital',
    root_core_plaid_oauth: '/plaid-oauth',
    root_core_navigation_settings: '/settings',
    root_core_navigation_settings_mobile: '/settings/m',
    root_core_navigation_settings_account: '/settings/account',
    root_core_navigation_settings_company: '/settings/company',
    root_core_navigation_settings_company_mobile: '/settings/company/m',
    root_core_navigation_settings_company_general: '/settings/company/general',
    root_core_navigation_settings_company_integrations:
        '/settings/company/integrations',
    root_core_navigation_settings_company_branding:
        '/settings/company/branding',
    root_core_navigation_settings_company_client_portal:
        '/settings/company/client-portal',
    root_core_navigation_settings_company_client_portal_preview:
        '/settings/company/client-portal/preview',
    root_core_navigation_settings_company_bankInfo: '/settings/company/bank',
    root_core_navigation_settings_company_paymentMethod:
        '/settings/company/payment-methods',
    root_core_navigation_settings_company_subscription: MEMBERSHIP_PAGE_PATH,
    root_core_navigation_settings_company_team: '/settings/company/team',
    root_core_navigation_settings_company_account_access:
        '/settings/company/account-access',
    root_core_navigation_settings_company_preferences:
        '/settings/company/preferences',
    root_core_navigation_settings_company_ai_preferences:
        '/settings/company/ai_preferences',
    root_core_navigation_settings_company_reviews: '/settings/company/reviews',
    root_core_navigation_settings_company_account_setup:
        '/settings/company/account-setup',
    root_core_navigation_settings_companySettings_library:
        '/settings/company/library',
    root_core_navigation_templates: '/templates/:templateTypeKey',
    root_core_navigation_my_templates: '/my-templates',
    root_core_navigation_my_templates_preview: '/my-templates',
    root_core_navigation_flows_template_gallery: '/template-gallery',
    root_core_navigation_tasks: '/tasks',
    root_core_navigation_facebook_leads: '/facebook_leads',
    root_core_navigation_templates_by_key:
        '/templates_editor/:templateModelKey',
    root_core_navigation_templatesEditor:
        '/templates_editor/:templateModelKey/:templateId',
    root_core_navigation_service_templates: '/services',
    root_core_oneComposer: '/templates_editor/email/:templateId',
    root_core_import_template: '/import-template-loader',
    root_core_template_redeem_error: '/import-template-redeem-error',
    root_core_navigation_settings_companySettings_automation:
        '/settings/company/automation',
    root_core_navigation_settings_company_quickbooks:
        '/settings/company/quickbooks',
    root_core_workspaceFileRedirection:
        '/workspace_file/:workspace_file_id/redirect',
    root_core_workspaceFilePaymentRedirection:
        '/workspace_file/:workspace_file_id/:payment_id/redirect',
    root_core_workspaceFile: '/workspace_file/:workspace_file_id',
    root_core_workspaceFile_stepProposal:
        '/workspace_file/:workspace_file_id/package',
    root_core_workspaceFile_stepQuestionnaire:
        '/workspace_file/:workspace_file_id/questionnaire',
    root_core_workspaceFile_brochure:
        '/workspace_file/:workspace_file_id/brochure',
    root_core_workspaceFile_timeline:
        '/workspace_file/:workspace_file_id/timeline',
    root_core_workspaceFile_stepAgreement:
        '/workspace_file/:workspace_file_id/agreement',
    root_core_workspaceFile_stepPayment:
        '/workspace_file/:workspace_file_id/payment/:payment_id',
    root_core_questionnaireSubmitted: '/questionnaire/submitted',
    root_core_receipt: '/receipt',
    root_core_navigation_brands: '/brands',
    root_core_pay: '/pay',
    root_core_navigation_lead_capture: '/lead_capture',
    root_core_navigation_gallery_dashboard: '/configure/flow_gallery',
    root_core_lifecycle_marketing_link: '/lifecycle_marketing_link/:link_type',
    root_core_navigation_process_mapping: '/my-process',
    root_core_process_mapping_editor: '/my-process/:process_id',
    root_core_navigation_finance_taxes: '/tax-hub',
    root_core_navigation_setup: '/setup',
    root_core_navigation_academy_resolve: '/academy/resolve',
    root_core_navigation_bookkeeping_reports_payments:
        '/bookkeeping/reports/payments',
    root_core_navigation_bookkeeping_reports_analytics:
        '/bookkeeping/reports/analytics',
    root_core_navigation_bookkeeping_reports: '/bookkeeping/reports',
    root_core_navigation_bookkeeping_expenses: '/bookkeeping/expenses',
    root_core_navigation_bookkeeping_reports_profit_loss:
        '/bookkeeping/reports/profit-loss',
    root_core_navigation_bookkeeping_settings_company_quickbooks:
        '/bookkeeping/settings/company/quickbooks'
} as const;

export type AppStateKey = keyof typeof AppStatesToUrl;
export type IAppStates = Record<AppStateKey, AppStateKey>;

export const AppStates: IAppStates = Object.fromEntries(
    Object.entries(AppStatesToUrl).map(([key]) => [key, key])
) as Record<AppStateKey, AppStateKey>;
